// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"550":"a706aa41","639":"0670679d","679":"d7049a5c"}[chunkId] + ".css";
};